import validateLimits from 'domain/Options/utils/validateLimits';

export const calcKitchenIslandErrorMessages = validateLimits;
